export default "__VITE_ASSET__CIUfNjg5__"